import { useContext } from 'react';
import { sTypeGrpIdContext } from './context';

export const useSTypeGrpId = () => {
  const handlers = useContext(sTypeGrpIdContext);
  return handlers;
};
